import React, { useContext } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import useChecklistService from '../../../app/services/hooks/useChecklistService';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';

interface Props {
    checklistId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const ChecklistSwitchChange = ({ checklistId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeChecklist, fetchingActiveChecklist } = useChecklistService();

    const active = (value: boolean) => {
        setChecked(value);

        activeChecklist(checklistId, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={checklistId} callback={active} />;
};

export default ChecklistSwitchChange;

